import { render } from "./Unit_Reservations.vue?vue&type=template&id=e16edf8e"
import script from "./Unit_Reservations.vue?vue&type=script&lang=js"
export * from "./Unit_Reservations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__